




import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import type { PDFDocumentProxy } from 'pdfjs-dist/types/display/api'

@Component
export default class PdfViewer extends Vue {
  pdf!: PDFDocumentProxy
  // page!: PDFPageProxy
  // renderTask!: RenderTask

  @Prop()
  readonly src!: string

  @Prop()
  readonly pageNo!: number

  @Watch('src', { immediate: true })
  async generate (src: string) {
    const pdfjs = require('pdfjs-dist/webpack.js')
    try {
      const loader = await pdfjs.getDocument(src)
      this.pdf = await loader.promise
      this.$emit('pdf-load', this.pdf)
      await this.pageView(this.pageNo)
    } catch (e) {
      if (!(e instanceof pdfjs.MissingPDFException)) throw e
    }
  }

  @Watch('pageNo')
  async pageView (pageNo: number) {
    if (this.pdf && this.$el) {
      try {
        const pageNumber = Math.min(this.pdf.numPages, Math.max(1, pageNo || 1))
        const page = await this.pdf.getPage(pageNumber)
        const viewportBase = page.getViewport({ scale: 1 })
        const scale = 1200 / viewportBase.width
        const viewport = page.getViewport({ scale: scale })
        const canvas = this.$el as HTMLCanvasElement
        const canvasContext = canvas.getContext('2d')
        if (canvasContext) {
          canvas.height = viewport.height + 30
          canvas.width = viewport.width
          const renderTask = page.render({ canvasContext, viewport })
          await renderTask.promise
        }
      } catch (e) {}
    }
  }

  // @Watch('src', { immediate: true })
  // async generate (src: string) {
  //   const pdfjs = require('pdfjs-dist/webpack.js')
  //   const loader = await pdfjs.getDocument(src)
  //   this.pdf = await loader.promise
  //   this.$emit('pdf-load', this.pdf)
  //   await this.pageView(this.pageNo)
  // }
  //
  // @Watch('pageNo')
  // async pageView (pageNo: number) {
  //   if (this.pdf && this.$el) {
  //     try {
  //       const pageNumber = Math.min(this.pdf.numPages, Math.max(1, pageNo || 1))
  //       this.page = await this.pdf.getPage(pageNumber)
  //       const viewport = this.page.getViewport({ scale: 1 })
  //
  //       const canvas = this.$el as HTMLCanvasElement
  //       const canvasContext = canvas.getContext('2d')
  //       canvas.height = viewport.height + 30
  //       canvas.width = viewport.width
  //
  //       this.renderTask = this.page.render({ canvasContext, viewport })
  //       await this.renderTask.promise
  //     } catch (e) {
  //       this.destroyPage(this.page)
  //     }
  //   }
  // }
  //
  // /* cleanup based on https://rossta.net/blog/building-a-pdf-viewer-with-vue-part-1.html **/
  //
  // @Watch('page')
  // cleanOldPage (page: PDFPageProxy, oldPage: PDFPageProxy) {
  //   this.destroyPage(oldPage)
  // }
  //
  // beforeDestroy () {
  //   this.destroyPage(this.page);
  // }
  //
  // destroyPage (page: PDFPageProxy) {
  //   if (page) {
  //     // PDFPageProxy#_destroy
  //     // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
  //     page._destroy()
  //     this.destroyRenderTask()
  //   }
  // }
  //
  // destroyRenderTask () {
  //   if (this.renderTask) {
  //     // RenderTask#cancel
  //     // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
  //     this.renderTask.cancel()
  //     delete this.renderTask
  //   }
  // }
}
